import { observable } from 'mobx';

export class TriageAlertState {
    @observable public visible: boolean = false;
    @observable public isCompleteUserFound: boolean = false;
}
